unit InstrumentScreenType;

interface

uses
  CategoryItemListType, InstrumentType, NetInstrumentItemListType, SupplierItemListType;

type
  TInstrumentScreenType = class
  private
    fInstrument: TInstrumentType;
    fCategoryItemList: TCategoryItemListType;
    fSupplierItemList: TSupplierItemListType;
    fNetInstrumentItemList: TNetInstrumentItemListType;
  public
    property Instrument: TInstrumentType read fInstrument;
    property CategoryItemList: TCategoryItemListType read fCategoryItemList;
    property SupplierItemList: TSupplierItemListType read fSupplierItemList;
    property NetInstrumentItemList: TNetInstrumentItemListType read fNetInstrumentItemList;
  end;

implementation

end.
